<template lang="slm">
  section style="margin-bottom: 0px;"
    .container
      .Issues
        .columns.Issues-container.is-multiline :style="{ marginBottom: 44 + 'px', display: 'flex' }"
          issue-card v-for="issue in issues" :issue="issue" :key="issue.id"

</template>

<script>
import IssueCard from '@/components/IssueCard'

export default {
  components: {
    'issue-card': IssueCard
  },
  data () {
    return {
      i: this.issues
    }
  },
  props: ['issues']
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/components/FrontpageIssueList.vue